<div class="row">
  <div class="col">
    <div>
      <label class="form-label">
        I will be applying
        <span
          *ngIf="controlIsRequired('RequestCreditTypeCD')"
          class="color-error"
          >*</span
        >
      </label>
    </div>
    <div
      class="form-check-inline mb-3"
      *ngFor="let item of applicationType; index as i"
    >
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          [value]="item.Value"
          [id]="item.Value"
          name="applicationType"
          [formControl]="getFormControl('RequestCreditTypeCD')"
          (change)="onChange(item.Value)"
        />
        <label class="form-check-label" [for]="item.Value">
          {{ item.Text }}
        </label>
      </div>
    </div>
  </div>
</div>
